import * as React from 'react'
import { FormikProps } from 'formik'
import { IMobilityOptionCategoryObject, IMobilityOptionObject } from '../../types'
import Checkbox from '../ui/Checkbox'
import Dropdown, { IDropdownOption } from '../ui/Dropdown'
import TextField from '../ui/TextField'

interface IMobilityDeviceFormProps {
  formikProps: FormikProps<IMobilityOptionObject>
  children: React.ReactNode
  categories: IMobilityOptionCategoryObject[]
}

const MobilityDeviceForm = (props: IMobilityDeviceFormProps) => {
  const { categories, children, formikProps } = props
  const { errors, handleChange, handleSubmit, touched, values } = formikProps

  const options: IDropdownOption[] = Object.values(categories)
                                           .map((it: IMobilityOptionCategoryObject) => ({
                                             label: it.name,
                                             value: it.id
                                           }))
  const defaultOption = options.length > 0 ? options[0] : null

  return (
    <form onSubmit={handleSubmit}>
      <div className='mb1'>
        <div className='h6'>Category</div>
        <Dropdown
          placeholder={'Category'}
          defaultOption={defaultOption}
          options={options}
          name={'categoryId'}
        />
        <div className='error'>
          {touched.categoryId && errors.categoryId && <span className='h6 font-red'>{errors.categoryId}</span>}
        </div>
      </div>
      <div className='mb1'>
        <TextField
          title='Name'
          name={'name'}
          optional={false}
          error={errors.name}
          classNameContainer={'mr1'}
          onChange={handleChange}
          value={values.name}
          className='mt1 p1 border-light-grey4 rounded h5'
          placeholder='Name'
        />
        <div className='error'>
          {touched.name && errors.name && <span className='h6 font-red'>{errors.name}</span>}
        </div>
      </div>
      <div className='mb1'>
        <Checkbox
          name='isTransferableSeat'
          value={values.isTransferableSeat}
          displayName={'Able to transfer to a seat?'}
        />
      </div>
      {children}
    </form>
  )
}

export default MobilityDeviceForm



// WEBPACK FOOTER //
// ./src/components/global-settings/MobilityDeviceForm.tsx